/* -------------------------------------------

	Name:		Kite Pride
	Date:		2022/12/20

---------------------------------------------  */
/*global jQuery, document, window, yall, setTimeout */
var i = 0,
	html_tag = document.documentElement,
	img_lazy = document.querySelectorAll('img[data-src]:not(.dont)'),
	isMobile = false,
	rtl_mode;
for (i = 0; i < img_lazy.length; i = i + 1) {
	img_lazy[i].classList.add('lazy');
}

function isTouchDevice() {
	"use strict";
	if (window.matchMedia("(pointer: coarse)").matches) {
		return true;
	} else {
		return false;
	}
}

function toggle_dropdowns_simple(el) {
	'use strict';
	if (el.classList.contains('toggle')) {
		el.classList.remove('toggle');
	} else {
		el.classList.add('toggle');
	}
}
if (window.mobileCheck() || isTouchDevice()) {
	isMobile = true;
}

function createElementWithClass(tag, classList) {
	'use strict';
	var tagElem = document.createElement(tag);
	if (!Array.isArray(classList)) {
		classList = [classList];
	}
	for (var i = 0; i < classList.length; i++) {
		tagElem.classList.add(classList[i]);
	}
	return tagElem;
}

function append_url(el, content, className, href, access) {
	'use strict';
	var link = createElementWithClass('a', className);
	if (href) {
		link.href = href;
	} else {
		link.href = './';
		link.setAttribute('role', 'button');
	}
	if (access === true) {
		link.setAttribute('tabindex', -1);
		link.setAttribute('aria-hidden', true);
		link.setAttribute('focusable', false);
	}
	link.innerHTML += content;
	el.appendChild(link);
}


document.addEventListener('DOMContentLoaded', function () {
	'use strict';
	yall({
		observeChanges: true,
		threshold: 500
	});
});
jQuery(function () {
	"use strict";
	var
		$ = jQuery.noConflict(),

		content_id = $(document.getElementById('content')),
		footer_id = document.getElementById('footer'),
		footer_date = footer_id ? footer_id.querySelectorAll('.date') : [],

		email_tag = document.getElementsByClassName('email'),
		list_collection = $(document.getElementsByClassName('list-collection')),
		list_gallery = $(document.getElementsByClassName('list-gallery')),
		list_logo = $(document.getElementsByClassName('list-logo')),
		list_product_slider = $(document.getElementsByClassName('list-product-slider')),
		list_recommended = $(document.getElementsByClassName('list-recommended')),
		list_testimonials = $(document.getElementsByClassName('list-testimonials')),
		list_ticker = $(document.getElementsByClassName('list-ticker')),

		Default = {
			utils: {
				start: function () {
					if (html_tag.getAttribute('dir') === 'rtl') {
						rtl_mode = true;
					}
				},
        layout: function () { 
          if ($('#companiesData').length) { 
            var divs = $("#companiesData > li");
            for (var i = 0; i < divs.length; i+=6) {
              divs.slice(i, i + 6).wrapAll("<li><ul></ul></li>");
            }
            $('#companiesTarget').append($("#companiesData").html());
          }
        },
				mails: function () {
					if (email_tag.length) {
						Array.from(email_tag).filter(function (el) {
							return el.tagName.toLowerCase() !== 'input' && el.tagName.toLowerCase() !== 'div';
						}).forEach(function (el) {
							el.innerText = el.innerText.replace('//', '@').replace(/\//g, '.');
							if (el.tagName.toLowerCase() === 'a') {
								el.setAttribute('href', 'mailto:' + el.innerText);
							}
						});
					}
				},
				date: function () {
					if (footer_date.length) {
						footer_date[0].innerText = (new Date()).getFullYear();
					}
				},
				mobile: function () {
					if (isMobile) {
						html_tag.classList.add('mobile');
					} else {
						html_tag.classList.add('no-mobile');
					}
				},
				done: function () {
					var tag = document.createElement('script');
					tag.src = scripts_async_url;
					document.body.appendChild(tag);
				},
				footer: function () {
					if (footer_id) {
						Array.from(footer_id.querySelectorAll('h1, h2, h3, h4, h5, h6')).forEach(function (el) {
							append_url(el, 'Close', 'header-toggle');
							el.querySelector('a.header-toggle').addEventListener('click', function (e) {
								toggle_dropdowns_simple(el.parentElement);
								e.preventDefault();
							});
						});
					}
					content_id.find('.link-btn.wa-float').each(function () {
						$(this).addClass('clone-me').clone().removeClass('clone-me').wrap('<div class="link-btn-sticky-out"><div class="link-btn-sticky-in"></div></div>').closest('.link-btn-sticky-out').insertAfter(content_id);
					});
				},
				owl: function () {
					if (list_recommended.length || list_logo.length || list_testimonials.length) {
						list_recommended.add(list_logo).add(list_testimonials).each(function () {
							var autoWidth = false;
							if ($(this).is('.list-testimonials')) {
								autoWidth = true;
							}
							if ($(this).children().length > 1) {
								$(this).owlLayout().children('.inner').owlCarousel({
									loop: false,
									nav: true,
									dots: true,
									autoHeight: true,
									lazyLoad: true,
									margin: 45,
									items: 1,
									rtl: rtl_mode,
									autoWidth: false,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									},
									responsive: {
										0: {
											autoWidth: autoWidth
										},
										760: {
											autoWidth: false
										}
									}
								});
							}
						});
					}
					if (list_collection.length) {
						list_collection.each(function () {
							if ($(this).hasClass('slider') && $(this).children().length > 3) {
								$(this).owlLayout().children('.inner').owlCarousel({
									loop: false,
									nav: true,
									dots: false,
									autoHeight: true,
									lazyLoad: true,
									margin: 40,
									items: 3,
									rtl: rtl_mode,
									onInitialized: function () {
										$(this.$element).owlSemantic();
										$(this.$element).find('.owl-nav button').css('height', $(this.$element).find('.owl-item.active:first figure').outerHeight() + 'px');
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
										$(this.$element).find('.owl-nav button').css('height', $(this.$element).find('.owl-item.active:first figure').outerHeight() + 'px');
									},
									responsive: {
										0: {
											items: 1,
											margin: 10
										},
										760: {
											items: 2,
											margin: 20
										},
										1000: {
											items: 3,
											margin: 40
										}
									}
								});
							}
						});
					}
					if (list_gallery.length) {
						list_gallery.each(function () {
							if ($(this).hasClass('slider') && $(this).children().length > 5) {
								var items = [1, 3, 4, 5];
								if ($(this).is('.width-33')) {
									items = [1, 2, 3, 3];
								}
								$(this).owlLayout().children('.inner').owlCarousel({
									loop: false,
									nav: true,
									dots: false,
									autoHeight: true,
									lazyLoad: true,
									margin: 20,
									items: items[3],
									rtl: rtl_mode,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									},
									responsive: {
										0: {
											items: items[0]
										},
										760: {
											items: items[1]
										},
										1000: {
											items: items[2]
										},
										1200: {
											items: items[3]
										}
									}
								});
							}
						});
					}
					if (list_ticker.length) {
						list_ticker.each(function () {
							$(this).children().clone().appendTo($(this));
							$(this).owlLayout().children('.inner').owlCarousel({
								mouseDrag: false,
								touchDrag: false,
								pullDrag: false,
								freeDrag: false,
								loop: true,
								nav: false,
								dots: false,
								autoHeight: true,
								lazyLoad: true,
								margin: 0,
								autoWidth: true,
								autoplay: true,
								slideTransition: 'linear',
								autoplayTimeout: 5000,
								autoplaySpeed: 5000,
								autoplayHoverPause: true,
								rtl: rtl_mode,
								onInitialized: function () {
									$(this.$element).owlSemantic();
								},
								onTranslated: function () {
									$(this.$element).owlSemantic();
								}
							});
						});
					}
					if (list_product_slider.length) {
						list_product_slider.each(function () {
							if ($(this).children().length > 1) {
								$(this).owlLayout();
								$(this).append('<div class="pager custom"></div>').children('.inner').children().each(function () {
									$(this).clone().addClass('cloned').appendTo($(this).parents('.is-slider:first').find('.pager.custom'));
								});
								$(this).children('.inner').owlCarousel({
									nav: false,
									dots: false,
									autoHeight: true,
									loop: false,
									items: 1,
									margin: 0,
									rtl: rtl_mode,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function (event) {
										$(this.$element).owlSemantic();
										$(this.$element).parents('.is-slider:first').find('[data-slide-index]').removeClass('current').parent().children('[data-slide-index="' + event.item.index + '"]').addClass('current');
									}
								});
								$(this).find('.cloned').each(function (i) {
									if ($(this).is(':has(a)')) {
										$(this).find('a').attr('data-slide-index', i).attr('role', 'button');
									} else {
										$(this).wrapInner('<a href="./" role="button" data-slide-index="' + i + '"></a>');
									}
								});
								$(this).find('.pager.custom').each(function () {
									$(this).clone().removeClass('custom').addClass('mobile').insertAfter($(this));
								});
								$(this).find('a[data-slide-index]').each(function () {
									if ($(this).closest('.cloned').is(':first-child')) {
										$(this).addClass('current').attr('aria-pressed', true);
									} else {
										$(this).attr('aria-pressed', false);
									}
								}).on('click', function () {
									var n = $(this),
										f = n.parents('.is-slider:first');
									f.find('.pager a[data-slide-index]').each(function (k, v) {
										if ((v = $(v)).is('[data-slide-index="' + n.attr('data-slide-index') + '"]')) {
											v.attr('aria-pressed', true).addClass('current');
										} else {
											v.attr('aria-pressed', false).removeClass('current');
										}
									});
									f.find('.owl-carousel:first').trigger('to.owl.carousel', n.attr('data-slide-index'));
									return false;
								});
								// Thumbnail slider
								$(this).find('.custom.pager').each(function () {
									if ($(this).children().length > 3) {
										$(this).addClass('thumb-slider').wrapInner('<div class="inner owl-carousel"></div>').children('.inner').children().wrap('<div class="item"></div>');
										$(this).children('.inner').owlCarousel({
											nav: true,
											dots: false,
											autoHeight: true,
											loop: false,
											rtl: rtl_mode,
											items: 3,
											margin: 32
										});
									}
								});
							}
						});
					}
				},
        shopify: function() {
          
          /**
           * Activate 'remove' links from cart after refresh
           */
          function initRemoveItem() { 
            $('.list-cart .remove').on('click', function(e) { 
              e.preventDefault();
  
              var str_variant_id = $(this).attr('data-variant-id');
              var variant_id = parseInt(str_variant_id);
              
              Shopify.removeItem(variant_id, function() {
                refreshCart();
              });
              
              return false;
            });
          }
          initRemoveItem();

          /**
           * Get custom image from shopify's CDN
           */
          function getImageWithCustomRatio(src_image, params) {
            var imageArr = src_image.split('.');
            var location = imageArr.length - 2;
            var oldStr = imageArr[location];
            imageArr[location] = oldStr + params;
            var imageWithCustomRatio = imageArr.join('.');
            return imageWithCustomRatio;
          }

          $('#singleAddToCart').on('click', function(e) {
            var button = $(this);
            e.preventDefault();
            var id = $('input[name=id]').val();
            console.log(id);
            if (id && id != '') { 
              $(button).text(window.variantStrings.adding);
              
              $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: { items: [{ quantity: 1, id: parseInt(id)}] },
                success: function() {
                  $(button).text(window.variantStrings.product_added);
                },
                error: function(response) {
                  $(button).text(window.variantStrings.unavailable);
                }
              }).always(function(){
                window.refreshCart();
                setTimeout(function() {
                  html_tag.classList.add('m6pn-big-open');
                  $('.module-panel#cart').addClass('toggle');
                  $(button).text(window.variantStrings.add_to_cart);
                }, 2500);
              });
            } else { 
              
            }
          });

          /**
           * Product Functions
           */
          if ($('.module-product').length) {
            function detectVariant() {
              var searchArr = [];
              $('#singleProductForm select').each(function() {
                var selectedVal = $(this).val();
                searchArr.push(selectedVal);
              });
  
              metaData['variants'].forEach((variant) => {
                if (variant['options'].equals(searchArr)) {
                  if (variant['available'] == false) { 
                    $('button#singleAddToCart').attr('disabled', true);
                    $('button#singleAddToCart').text('Out of Stock');
                  } else {
                    $('button#singleAddToCart').attr('disabled', false);
                    $('button#singleAddToCart').text('Add To Cart');
                  }
                  $('#variantPrice').text(Shopify.formatMoney(variant['price'], '${{amount_no_decimals}}'))
                  $('input[name=id]').val(variant['id']);
                  console.log(variant['id']);
                }
              });
            }
            detectVariant();
  
            $('.module-product').find('select').on('change', function(){
              detectVariant();
            });
          }

          $('.quick-add a').on('click', function(e) {
            e.preventDefault();
            var button = $(this);
            var id = $(button).attr('data-variant-id');
            // console.log('quick add: ',id);
            if (id && id != '') { 
              $(button).text(window.variantStrings.adding);
              
              $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: { items: [{ quantity: 1, id: parseInt(id)}] },
                success: function() {
                  $(button).text(window.variantStrings.product_added);
                },
                error: function(response) {
                  $(button).text(window.variantStrings.unavailable);
                }
              }).always(function(){
                window.refreshCart();
                setTimeout(function() {
                  html_tag.classList.add('m6pn-big-open');
                  $('.module-panel#cart').addClass('toggle');
                  $(button).text(window.variantStrings.add_to_cart);
                }, 2500);
              });
            } 
          });

          // update cart values from .input-amount
          function updateCartValues() {
						$('.list-cart .input-amount a').on('click', function() {
              console.log('clic');
							var input = $(this).parent().children('input');
							input.css({ 'opacity': '0.5' });
	
							var quantity = input.val(),
                variant_id = input.attr('data-variant-id');

                console.log(input, quantity, variant_id);
	
							fetch('/cart/change.js', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json'
								},
								body: JSON.stringify({ quantity: quantity, variant_id: variant_id })
							})
							.then(response => {
								refreshCart();
                console.log(response);
							})
							.catch((error) => {
								console.error('Error:', error);
							});
	
							return false;
						});
					}
					updateCartValues();

          /** 
           * Update Cart Note
           */
          $('#addNotes').on('change',function() {
            if(this.checked) {
              $('#cartNotesContainer').removeClass('hidden');
              $('#cart .gift').addClass('on');
            } else { 
              $('#cartNotesContainer').addClass('hidden');
              $('#cart .gift').removeClass('on');
            }
          });
          
          $('#cartNote').on('change keydown', function () {
            $.post('/cart.js', {
              attributes: {
                'Order Note': $(this).val()
              }
              }).done(function () {});
          });

          /**
           * Add Gift wrap Item
           */
          $('#addWrap').on('change',function() {
            console.log('change');
            if(this.checked) {
              let formData = {
                'items': [{
                 'id': 39867284062391,
                 'quantity': 1
                 }]
               };
               fetch('/cart/add.js', {
                 method: 'POST',
                 headers: {'Content-Type': 'application/json'},
                 body: JSON.stringify(formData)
               })
               .then(response => {
                 refreshCart();
               })
            } else {
              let formData = {
                'items': [{
                 'id': 39867284062391,
                 'quantity': 0
                 }]
               };
               fetch('/cart/update.js', {
                 method: 'POST',
                 headers: {'Content-Type': 'application/json'},
                 body: JSON.stringify(formData)
               })
               .then(response => {
                 refreshCart();
               })
            }
          });


          $('#cart').on('submit', function(e) {
            e.preventDefault();
            if (html_tag.getAttribute('lang') === 'he') {
              window.location.href = '/he/checkout';
            } else {
              window.location.href = '/checkout';  
            }
          })

          /**
           * Refresh Cart function
           */
          window.refreshCart = function() {

            $.getJSON("/cart.js", function(json) {
              // console.log(json);

              var countString = '';
              if (html_tag.getAttribute('dir') === 'rtl') {
                if (json.item_count == 1) {
                  countString = 'פריט 1';
                } else {
                  countString = json.item_count + ' פריטים';
                }
              } else {
                if (json.item_count == 1) {
                  countString = '1 item';
                } else {
                  countString = json.item_count + ' items';
                }
              }
              $('#cartCount').text(countString);
              
              $('.list-cart li').remove(); // clean old items

              var itemsArr = [];
              
              if (json.item_count > 0) {
                // update .list-cart
                var index = 1;
                json.items.forEach(item => {

                  // Item Options String
                  var optionsString = "";
                  if (item.product_has_only_default_variant == false) {
                    item.options_with_values.forEach(option => {
                      optionsString += '<li><span>'+option.name + "</span>" + option.value + "</li>";
                    });
                  } 

                  itemsArr.push(item.id);
                  
                  // Item Image
                  var cart_item_image = (item.image) ? getImageWithCustomRatio(item.image, '_135x135') : 'https://via.placeholder.com/135x135';

                  // append item to .list-cart
                  $('.list-cart').append(
                    '<li>'+
                      '<figure><img src="'+cart_item_image+'" alt="'+item.product_title+'" width="135" height="135"></figure>'+
                      '<div>'+
                        '<h5><a href="'+item.url+'">'+item.product_title+'</a></h5>'+
                        '<p><span class="money conversion-bear-money">'+Shopify.formatMoney(item.original_price, '{{amount_no_decimals}} ILS')+'</span></p>'+
                        '<div class="cols">'+
                          '<p class="input-amount">'+
                            '<label for="ia'+index+'" class="hidden">Amount</label>'+
                            '<input type="number" id="ia'+index+'" name="ia'+index+'" value="'+item.quantity+'" data-variant-id="'+item.variant_id+'" min="0" required>'+
                          '</p>'+
                          '<p><a href="./" data-variant-id="'+item.variant_id+'" class="remove"><i aria-hidden="true" class="icon-trash"></i> <span class="hidden">Remove</span></a></p>'+
                        '</div>'+
                      '</div>'+
                    '</li>'
                  );
                  index++;                  
                });
                // set input Amount
                var evt = new CustomEvent("semanticInput");
                window.dispatchEvent(evt);
                
                updateCartValues(); // listen to input amount
                initRemoveItem(); // enable remove

                conversionBearAutoCurrencyConverter.convertPricesOnPage(); // refresh prices

                const found = itemsArr.find(element => element == 39867284062391);
                if (found) { 
                  $('#addWrap').attr('checked', true);
                } else { 
                  $('#addWrap').attr('checked', false);
                }

                // Total value
                $('#cart #cartTotal').html(
                  window.cartStrings.subtotal+': <span class="money conversion-bear-money">'+Shopify.formatMoney(json.total_price, '{{amount_no_decimals}} ILS') + '</span>'
                );

                // show checkout + note + footer
                $('#cart').removeClass('empty');

              } else { 

                $('#cartCount').text('');
                
                // empty placeholder
                $('.list-cart').append(
                  '<li><p class="text-center">Your Cart is Empty</p></li>'
                );

                // remove total
                $('#cart #cartTotal').html('');

                // hide checkout + note + footer
                $('#cart').addClass('empty');
              }
            });
          }
          window.refreshCart();
        },
			}

		};
	setTimeout(function () {
		Default.utils.start();
    Default.utils.layout();
		Default.utils.mails();
		Default.utils.date();
		Default.utils.footer();
    Default.utils.shopify();
		Default.utils.owl();
		Default.utils.mobile();
		Default.utils.done();
	}, 0);
});

/*!*/

// +/- input
var input_amount_event = new CustomEvent('semanticInput');
window.addEventListener('semanticInput', function (evt) {
"use strict";
var input_amount = document.querySelectorAll('.input-amount:not(.semantic-input-initialized)');
if (input_amount.length) {
    Array.from(input_amount).forEach(function (el) {
        el.classList.add('semantic-input-initialized');
        var inc = createElementWithClass('a', 'incr'),
            dec = createElementWithClass('a', 'decr');

        inc.setAttribute('href', './');
        dec.setAttribute('href', './');
        inc.setAttribute('aria-label', 'Increase by 1');
        dec.setAttribute('aria-label', 'Descrease by 1');
        el.innerHTML = '<span class="semantic-amount">' + el.innerHTML + '</span>';

        Array.from(el.children).forEach(function (el) {
            var inp = el.querySelector('input');
            el.appendChild(inc);
            el.appendChild(dec);
            if (parseFloat(inp.value) === 1 || inp.value === '') {
                el.querySelector('.decr').classList.add('disabled');
            }
            if (inp.hasAttribute('max') && inp.value === parseFloat(inp.getAttribute('max'))) {
                el.querySelector('.incr').classList.add('disabled');
            }
        });
        if (el.parentNode.classList.contains('submit')) {
            Array.from(el.parentNode.querySelectorAll('button')).forEach(function (em) {
                if (em.classList.contains('size-m')) {
                    el.classList.add('size-m');
                }
                if (em.classList.contains('size-l')) {
                    el.classList.add('size-l');
                }
            });
        }
    });
    Array.prototype.slice.call(input_amount).map(function (el) {
        return {
            input: el.querySelector('input'),
            decr: el.querySelector('.decr'),
            incr: el.querySelector('.incr'),
            get value() {
                return parseInt(this.input.value);
            },
            set value(newValue) {
                var input = el.querySelector("input"),
                    decrElements,
                    incrElements,
                    dataLink,
                    inputLink,
                    decrElementLinkData,
                    incrElementLinkData;
                input.value = newValue;

                decrElements = [this.decr]; // if has data-link, it will change decr for data-link element too
                incrElements = [this.incr]; // if has data-link, it will change decr for data-link element too

                // check if input has a data-link attribute. If it has, get element associated with and set new value
                dataLink = input.getAttribute("data-link");
                if (dataLink) {
                    inputLink = document.querySelector(dataLink);
                    if (inputLink) {
                        inputLink.value = newValue;

                        decrElementLinkData = inputLink.closest(".input-amount");
                        incrElementLinkData = inputLink.closest(".input-amount");
                        if (decrElementLinkData) {
                            decrElementLinkData = decrElementLinkData.querySelector(".decr");
                            decrElements.push(decrElementLinkData);
                        }
                        if (incrElementLinkData) {
                            incrElementLinkData = incrElementLinkData.querySelector(".incr");
                            incrElements.push(incrElementLinkData);
                        }
                    }
                }

                // loop through all decr elements to change its class if needed
                Array.from(decrElements).forEach(function (decrEl) {
                    //decrElements.forEach(decrEl => {
                    if (parseFloat(newValue) < 2) {
                        decrEl.classList.add('disabled');
                    } else {
                        if (decrEl.classList.contains('disabled')) {
                            decrEl.classList.remove('disabled');
                        }
                    }
                });
                Array.from(incrElements).forEach(function (incrEl) {
                    if (input.hasAttribute('max')) {
                        if (parseFloat(newValue) === parseFloat(input.getAttribute('max'))) {
                            incrEl.classList.add('disabled');
                        } else {
                            if (incrEl.classList.contains('disabled')) {
                                incrEl.classList.remove('disabled');
                            }
                        }
                    }
                });
            }
        };
    }).forEach(function (el) {
        var evt = new Event('change');
        el.decr.addEventListener('click', function (e) {
            if (el.value > 1) {
                el.value -= 1;
            }
            e.preventDefault();
        });
        el.incr.addEventListener('click', function (e) {
            if (el.input.hasAttribute('max')) {
                if (el.value < parseFloat(el.input.getAttribute('max'))) {
                    el.value += 1;
                }
            } else {
                el.value += 1;
            }
            if (isNaN(el.value)) {
                el.value = 1;
            }
            e.preventDefault();
        });
        el.input.addEventListener('change', function () {
            el.value = parseFloat(el.value);
            if (isNaN(el.value)) {
                el.value = 1;
                el.decr.classList.add('disabled');
            }
        });
    });
}
});
window.dispatchEvent(input_amount_event);